if (!customElements.get("product-info")) {
  class ProductInfo extends HTMLElement {
    abortController = undefined;
    onVariantChangeUnsubscriber = undefined;
    pendingRequestUrl = null;
    preProcessHtmlCallbacks = [];
    postProcessHtmlCallbacks = [];

    constructor() {
      super();

      this.onWindowLoad = this.onWindowLoad.bind(this);
    }

    get productId() {
      return this.getAttribute('data-product-id');
    }

    get sectionId() {
      return this.dataset.originalSection || this.dataset.sectionId;
    }

    get disableSelectedVariantDefault() {
      return this.dataset.disableSelectedVariantDefault === "true" || false;
    }

    get enableVariantGroupImages() {
      return this.dataset.enableVariantGroupImages === "true" || false;
    }

    get enableHistoryState() {
      return this.dataset.enableHistoryState === "true" || false;
    }

    get viewMode() {
      return this.dataset.viewMode || 'main-product'
    }

    get pickupAvailability() {
      return this.querySelector(`pickup-availability`);
    }

    get productForm() {
      return this.querySelector('product-form'); // fallback: product-form.m-product-form--main
    }

    get productMedia() {
      return this.querySelector(`[id^="MediaGallery-${this.dataset.sectionId}"]`);
    }

    get variantPicker() {
      return this.querySelector('variant-picker');
    }

    get quantityInput() {
      return this.querySelector(`m-quantity-input input`);
    }
    get quantityInputStickyAtc() {
      return this.querySelector(`.m-sticky-addtocart m-quantity-input input`);
    }

    get stickyAtc() {
      return this.querySelector('sticky-atc');
    }

    connectedCallback() {
      if (this.viewMode === "main-product") {
        window.addEventListener("load", this.onWindowLoad);
      }

      this.init();
      this.waitForSkio();
    }

    disconnectedCallback() {
      window.removeEventListener("load", this.onWindowLoad);
      this.onVariantChangeUnsubscriber();
      this.cartUpdateUnsubscriber?.();
      if (this.skioPriceObserver) {
        this.skioPriceObserver.disconnect();
        this.skioPriceObserver = null;
      }

  const productForm = document.getElementById(
    `product-form-${this.dataset.sectionId}`
  );

if (this.skioPlanPicker && this.skioClickHandler) {
  this.skioPlanPicker.removeEventListener(
    'click',
    this.skioClickHandler,
    true
  );
}

if (this.skioPlanPicker && this.skioChangeHandler) {
  this.skioPlanPicker.removeEventListener(
    'change',
    this.skioChangeHandler,
    true
  );
}

this.skioPlanPicker = null;
this.skioClickHandler = null;
this.skioChangeHandler = null;
this.skioPriceEventsBound = false;
    }

    init() {
      this.currentVariant =
        this.getSelectedVariant(this);

      /*
      * Сохраняем стандартную вариацию Shopify до того,
      * как тема может очистить визуальный выбор опций.
      */
      const initialVariant = this.currentVariant;

      this.quantityInputs = [];

      if (this.quantityInput) {
        this.quantityInputs.push(this.quantityInput);
      }
      if (this.quantityInputStickyAtc) {
        this.quantityInputs.push(this.quantityInputStickyAtc);
      }

      if (this.disableSelectedVariantDefault) {
        this.handleDisableSelectedVariantDefault();
      }

      this.onVariantChangeUnsubscriber = MinimogEvents.subscribe(
        MinimogTheme.pubSubEvents.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this)
      );

      this.showFeaturedMedia = this.dataset.showFeaturedMedia === "true" || false;

      this.initialMedias = this.productMedia ? this.productMedia.querySelectorAll('.m-product-media--item') : null;
      this.initialThumbs = this.productMedia ? this.productMedia.querySelectorAll(".m-product-media--slider__thumbnails [data-media-type]") : null;

      if (this.enableVariantGroupImages) {
        this.variantGroupImagesData = this.getVariantGroupImagesData();
        this.showFeaturedMedia = false;
      };

      this.initQuantityHandlers();

      /*
      * На первой загрузке variant уже определён Shopify,
      * даже если параметра variant нет в URL.
      */
      if (initialVariant) {
        this.updateInitialButtonPrices(
          initialVariant
        );

        requestAnimationFrame(() => {
          this.updateInitialButtonPrices(
            initialVariant
          );
        });

        /*
        * Sticky-разметка может инициализироваться позже.
        */
        setTimeout(() => {
          this.updateInitialButtonPrices(
            initialVariant
          );
        }, 100);
      }

      if (this.currentVariant && !this.showFeaturedMedia) {
        this.updateMedia(this.currentVariant);
      }
    }

    getVariantGroupImagesData() {
      return (
        JSON.parse(
          this.querySelector('#variantGroup[type="application/json"]')
            .textContent
        ) || {}
      );
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (!this.contains(event.target)) return;

      const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      const shouldSwapProduct = this.dataset.url !== productUrl;
      // this.pendingRequestUrl = productUrl;
      const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
        targetId: target.id,
        callback: shouldSwapProduct
          ? this.handleSwapProduct(productUrl, shouldFetchFullPage, this.viewMode)
          : this.handleUpdateProductInfo(productUrl, this.viewMode),
      });
    }

    renderProductInfo({ requestUrl, targetId, callback }) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          callback(html);
        })
        .then(() => {
          // set focus to last clicked option value
          document.querySelector(`#${targetId}`)?.focus();
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
        });
    }

    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
      const params = [];

      !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`);
      }

      return `${url}?${params.join('&')}`;
    }

    handleUpdateProductInfo(productUrl, viewMode) {
      return (html) => {
        const quickView = html.querySelector('#MainProduct-quick-view__content');
        if (quickView && viewMode === 'quick-view') {
          html = new DOMParser().parseFromString(quickView.innerHTML, "text/html");
        }

        const variant = this.getSelectedVariant(html);

        this.pickupAvailability?.update(variant);
        this.updateOptionValues(html);
        this.updateURL(productUrl, variant?.id);
        this.updateVariantInputs(variant?.id);

        if (!variant) {
          this.setUnavailable();
          return;
        }

        this.updateMedia(variant);

        const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
          const source = html.getElementById(`${id}-${this.sectionId}`);
          const destination = this.querySelector(`#${id}-${this.dataset.sectionId}`);
          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle('m:hidden', shouldHide(source));
          }
        };

        updateSourceFromDestination('Price');
        updateSourceFromDestination("Inventory");
        updateSourceFromDestination("Sku");
        updateSourceFromDestination("Availability");
        updateSourceFromDestination("Volume");
        updateSourceFromDestination('PricePerItem');

        this.updateQuantityRules(this.sectionId, this.productId, html);
        this.querySelector(`#QuantityRules-${this.dataset.section}`)?.classList.remove('m:hidden');
        this.querySelector(`#VolumeNote-${this.dataset.section}`)?.classList.remove('m:hidden');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        
this.currentVariant = variant;

requestAnimationFrame(() => {
  this.updateSkioComparePrice(variant);
});

setTimeout(() => {
  this.updateSkioComparePrice(variant);
}, 100);

const soldOut = variant ? variant.available === false : true;

this.toggleAddButton(
  soldOut,
  soldOut ? window.MinimogStrings.soldOut : null,
  true,
  variant
);

        MinimogEvents.emit(MinimogTheme.pubSubEvents.variantChange, {
          data: { variant, sectionId: this.sectionId, html },
        });

        document.dispatchEvent(
          new CustomEvent('variant:changed', {
            detail: {
              variant: this.currentVariant,
            },
          })
        );
      };
    }

    handleSwapProduct(productUrl, updateFullPage, viewMode) {
      return (html) => {
        const quickView = html.querySelector('#MainProduct-quick-view__content');
        if (quickView && viewMode === 'quick-view') {
          html = new DOMParser().parseFromString(quickView.innerHTML, "text/html");
        }

        const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
        const productInfo = html.querySelector(selector);
        const variant = this.getSelectedVariant(productInfo);
        productInfo.dataset.disableSelectedVariantDefault = false;

        this.updateURL(productUrl, variant?.id);

        if (updateFullPage) {
          document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
          HTMLUpdateUtility.viewTransition(
            document.querySelector('main'),
            html.querySelector('main'),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
        } else {
          HTMLUpdateUtility.viewTransition(
            this,
            productInfo,
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
        }

        this.currentVariant = variant;
      };
    }

    getSelectedVariant(productInfoNode) {
      const selectedVariant = productInfoNode.querySelector('variant-picker [data-selected-variant]')?.innerHTML;
      return !!selectedVariant ? JSON.parse(selectedVariant) : null;
    }

    updateURL(url, variantId) {
      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${url}${this.enableHistoryState && variantId ? `?variant=${variantId}` : ''}`);
    }

    updateVariantInputs(variantId) {
      document
        .querySelectorAll(`#product-form-${this.dataset.sectionId}, #product-form-installment-${this.dataset.sectionId}`)
        .forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateOptionValues(html) {
      const variantPicker = html.querySelector('variant-picker');
      if (variantPicker) {
        HTMLUpdateUtility.viewTransition(this.variantPicker, variantPicker, this.preProcessHtmlCallbacks);
      }
    }

    setUnavailable() {
      const productForm = document.getElementById(
        `product-form-${this.sectionId}`
      );
      const addButton = productForm.querySelector('[name="add"]');

      if (addButton) {
        this.toggleAddButton(true, window.MinimogStrings.unavailable);
      }

      const selectors = [
        "Price",
        "Inventory",
        "Sku",
        "Availability"
      ]
        .map((id) => `#${id}-${this.sectionId}`)
        .join(", ");
      document
        .querySelectorAll(selectors)
        .forEach((selector) => selector.classList.add('m:hidden'));
    }

updateInitialButtonPrices(variant) {
  if (!variant || variant.available === false) {
    return;
  }

  /*
   * Если пользователь уже выбрал другую вариацию,
   * не возвращаем начальную цену.
   */
  if (
    this.currentVariant &&
    this.currentVariant.id !== variant.id
  ) {
    return;
  }

  const mainProductForm =
    document.getElementById(
      `product-form-${this.dataset.sectionId}`
    );

  const productSection =
    mainProductForm?.closest(".m-product") ||
    mainProductForm?.closest(
      "[data-section-id]"
    ) ||
    this;

  /*
   * У товаров с подпиской ценой управляет Skio.
   */
  const hasSubscriptionBlock =
    productSection.querySelector(
      "[skio-plan-picker]"
    );

  if (hasSubscriptionBlock) return;

  let formattedPrice;

  if (
    typeof Shopify !== "undefined" &&
    typeof Shopify.formatMoney === "function"
  ) {
    formattedPrice = Shopify.formatMoney(
      variant.price,
      window.themeSettings?.moneyFormat ||
        "${{amount}}"
    );
  } else {
    formattedPrice =
      `$${(variant.price / 100).toFixed(2)}`;
  }

  const text =
    `${window.MinimogStrings.addToCart} • ${formattedPrice}`;

  const buttons = [];

  /*
   * Основная кнопка.
   */
  const mainButton =
    mainProductForm?.querySelector(
      'button[name="add"]'
    );

  if (mainButton) {
    buttons.push(mainButton);
  }

  /*
   * Sticky-кнопка необязательна.
   * Если sticky отключена или отсутствует,
   * основная кнопка всё равно обновится.
   */
  document
    .querySelectorAll(
      `sticky-atc[data-product-id="${this.productId}"] button[name="add"]`
    )
    .forEach(button => {
      buttons.push(button);
    });

  buttons.forEach(button => {
    const buttonText = button.querySelector(
      ".m-add-to-cart--text"
    );

    if (!buttonText) return;

    buttonText.textContent = text;
    button.dataset.atcText = text;

    /*
     * disabled здесь намеренно не изменяем.
     */
  });
}

toggleAddButton(
  disable = true,
  text,
  modifyClass = true,
  variant = null
) {
  const productForm = document.getElementById(
    `product-form-${this.dataset.sectionId}`
  );

  if (!productForm) return;

  const addButton = productForm.querySelector('[name="add"]');

  const addButtonText = productForm.querySelector(
    '[name="add"] > span.m-add-to-cart--text'
  );

  if (!addButton || !addButtonText) return;

  const price = variant
    ? (variant.price / 100).toFixed(2)
    : '';

  /*
   * Если вариант доступен, кнопка должна быть активной.
   */
  if (variant && variant.available === true) {
    disable = false;
    text = null;
  }

  /*
   * Отключаем кнопку для недоступного варианта.
   */
  if (disable) {
    addButton.setAttribute('disabled', 'disabled');

    if (text) {
      addButtonText.textContent = text;
    }

    return;
  }

  /*
   * Включаем кнопку и сначала показываем
   * стандартную цену выбранного варианта Shopify.
   */
  addButton.removeAttribute('disabled');

  addButtonText.textContent =
    `${window.MinimogStrings.addToCart} • $${price}`;

  /*
   * Если у товара есть Skio, заменяем стандартную цену
   * на актуальную цену One-time или Subscription.
   */
  requestAnimationFrame(() => {
    this.updateAddButtonSkioPrice();
  });
}

updateSkioComparePrice(variant = this.currentVariant) {
  if (!variant) return;

  const productForm = document.getElementById(
    `product-form-${this.dataset.sectionId}`
  );

  const productSection =
    productForm?.closest('.m-product') ||
    productForm?.closest('[data-section-id]') ||
    this;

  const skioPlanPicker = productSection.querySelector(
    '[skio-plan-picker]'
  );

  if (!skioPlanPicker) return;

  const subscriptionInput = skioPlanPicker.querySelector(
    '[skio-selling-plan-group]'
  );

  const subscriptionBlock = subscriptionInput?.closest(
    '.skio-group-container'
  );

  /*
   * При необходимости замените селектор на класс вашего
   * конкретного перечёркнутого элемента.
   */
  const comparePriceElement = skioPlanPicker.querySelector(
    '[skio-subscription-full-price]'
  );

  if (!comparePriceElement) return;

  /*
   * Обычно в подписке перечёркивается обычная цена варианта.
   * Если нужна именно Shopify compare_at_price, используйте:
   *
   * const priceInCents =
   *   variant.compare_at_price || variant.price;
   */
  const priceInCents = variant.price;

  const formattedPrice =
    typeof Shopify?.formatMoney === 'function'
      ? Shopify.formatMoney(
          priceInCents,
          window.themeSettings?.moneyFormat || '${{amount}}'
        )
      : `$${(priceInCents / 100).toFixed(2)}`;

  if (comparePriceElement.textContent.trim() !== formattedPrice) {
    comparePriceElement.textContent = formattedPrice;
  }
}

updateAddButtonSkioPrice(purchaseType = null) {
  const productForm = document.getElementById(
    `product-form-${this.dataset.sectionId}`
  );

  if (!productForm) return;

  const addButton = productForm.querySelector('[name="add"]');

  const addButtonText = productForm.querySelector(
    '[name="add"] > span.m-add-to-cart--text'
  );

  if (!addButton || !addButtonText || addButton.disabled) {
    return;
  }

  const productSection =
    productForm.closest('.m-product') ||
    productForm.closest('[data-section-id]') ||
    this;

  /*
   * Ищем общий Skio picker, внутри которого находятся
   * и Subscription, и One-time purchase.
   */
  const skioPlanPicker = productSection.querySelector(
    '[skio-plan-picker]'
  );

  if (!skioPlanPicker) return;

  if (purchaseType) {
    this.skioSelectedPurchaseType = purchaseType;
  }

  /*
   * Дополнительно проверяем реальное состояние radio.
   * Это защищает от рассинхронизации состояния.
   */
  const checkedInput = skioPlanPicker.querySelector(
    '.skio-group-input:checked'
  );

  if (checkedInput) {
    if (checkedInput.hasAttribute('skio-one-time')) {
      this.skioSelectedPurchaseType = 'onetime';
    } else if (
      checkedInput.hasAttribute('skio-selling-plan-group')
    ) {
      this.skioSelectedPurchaseType = 'subscription';
    }
  }

  const priceElement =
    this.skioSelectedPurchaseType === 'subscription'
      ? skioPlanPicker.querySelector(
          '[skio-subscription-price]'
        )
      : skioPlanPicker.querySelector(
          '[skio-onetime-price]'
        );

  const price = priceElement?.textContent.trim();

  if (!price) return;

  addButtonText.textContent =
    `${window.MinimogStrings.addToCart} • ${price}`;
}

bindSkioPriceUpdates() {
  if (this.skioPriceEventsBound) return;

  const productForm = document.getElementById(
    `product-form-${this.dataset.sectionId}`
  );

  if (!productForm) return;

  const productSection =
    productForm.closest('.m-product') ||
    productForm.closest('[data-section-id]') ||
    this;

  /*
   * Здесь тоже используем общий fieldset,
   * а не первый .skio-group-container.
   */
  const skioPlanPicker = productSection.querySelector(
    '[skio-plan-picker]'
  );

  if (!skioPlanPicker) return;

  this.skioPriceEventsBound = true;
  this.skioPlanPicker = skioPlanPicker;

  const sellingPlanInput =
    productForm.querySelector('input[name="selling_plan"]') ||
    skioPlanPicker.querySelector('input[name="selling_plan"]');

  this.skioSelectedPurchaseType = sellingPlanInput?.value
    ? 'subscription'
    : 'onetime';

  /*
   * Click оставляем как дополнительную страховку.
   */
  this.skioClickHandler = event => {
    const label = event.target.closest(
      'label.skio-group-label'
    );

    if (!label || !skioPlanPicker.contains(label)) {
      return;
    }

    const labelFor = label.getAttribute('for') || '';

    let purchaseType = null;

    if (labelFor.startsWith('skio-one-time-')) {
      purchaseType = 'onetime';
    } else if (
      labelFor.startsWith('skio-selling-plan-group-')
    ) {
      purchaseType = 'subscription';
    }

    if (!purchaseType) return;

    this.skioSelectedPurchaseType = purchaseType;

    /*
     * Сразу передаём тип покупки, не полагаясь на то,
     * успел ли Skio переключить checked.
     */
    this.updateAddButtonSkioPrice(purchaseType);

    requestAnimationFrame(() => {
      this.updateAddButtonSkioPrice(purchaseType);
    });

    setTimeout(() => {
      this.updateAddButtonSkioPrice(purchaseType);
    }, 100);
  };

  /*
   * Change — более надёжное событие для radio inputs.
   */
  this.skioChangeHandler = event => {
    const input = event.target.closest(
      '.skio-group-input'
    );

    if (!input || !skioPlanPicker.contains(input)) {
      return;
    }

    let purchaseType = null;

    if (input.hasAttribute('skio-one-time')) {
      purchaseType = 'onetime';
    } else if (
      input.hasAttribute('skio-selling-plan-group')
    ) {
      purchaseType = 'subscription';
    }

    if (!purchaseType) return;

    this.skioSelectedPurchaseType = purchaseType;

    requestAnimationFrame(() => {
      this.updateAddButtonSkioPrice(purchaseType);
    });
  };

  skioPlanPicker.addEventListener(
    'click',
    this.skioClickHandler,
    true
  );

  skioPlanPicker.addEventListener(
    'change',
    this.skioChangeHandler,
    true
  );

this.skioPriceObserver = new MutationObserver(() => {
  this.updateAddButtonSkioPrice(
    this.skioSelectedPurchaseType
  );

  this.updateSkioComparePrice(
    this.currentVariant
  );
});

  this.skioPriceObserver.observe(skioPlanPicker, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['checked', 'class', 'value']
  });

  this.updateAddButtonSkioPrice(
    this.skioSelectedPurchaseType
  );
}

waitForSkio() {
  /*
   * Не запускаем ожидание повторно.
   */
  if (this.skioWaitStarted) return;

  this.skioWaitStarted = true;

  let attempts = 0;
  const maxAttempts = 100;

  const interval = setInterval(() => {
    attempts++;

    const productForm = document.getElementById(
      `product-form-${this.dataset.sectionId}`
    );

    if (!productForm) {
      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }

      return;
    }

    const productSection =
      productForm.closest('.m-product') ||
      productForm.closest('[data-section-id]') ||
      document;

    const skioPlanPicker = productSection.querySelector(
  '[skio-plan-picker]'
);

if (skioPlanPicker) {
      clearInterval(interval);
      this.bindSkioPriceUpdates();
      return;
    }

    /*
     * Через 10 секунд прекращаем проверку.
     * Для товаров без Skio это нормальное поведение.
     */
    if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 100);
}

    updateMedia(variant) {
      if (!this.productMedia) return;
      if (this.enableVariantGroupImages && this.variantGroupImagesData.enable) {
        this.handleVariantGroupImage(variant);

        if (this.productMedia.slider) {
          this.productMedia.slider.updateSlides();
          this.productMedia.navSlider.updateSlides();

          this.productMedia.slider.slideTo(0);
          this.productMedia.navSlider.slideTo(0);

          this.productMedia.handleSlideChange();
        }
        if (this.productMedia.enableImageZoom) {
          this.productMedia.handlePhotoswipe();
        }
      } else {
        const setActiveMedia = () => {
          if (typeof this.productMedia.setActiveMedia === 'function') {
            this.productMedia.init();
            this.productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }
    }

    handleDisableSelectedVariantDefault() {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("variant")) return;

      this.pickerFields = this.querySelectorAll("[data-picker-field]");

      this.pickerFields && this.pickerFields.forEach((field) => {
        let pickerType = field.dataset.pickerField;
        switch (pickerType) {
          case "select":
            let selectBox = field.querySelector("select");
            let option = document.createElement("option");
            option.text = this.dataset.variantOptionNoneText;
            option.setAttribute("disabled", "");
            option.setAttribute("selected", "");

            selectBox.add(option, 0);
            break;
          default:
            let checkedInputs = field.querySelectorAll("input:checked");
            checkedInputs &&
              checkedInputs.forEach(function (input) {
                input.removeAttribute("checked");
              });
            break;
        }

        field.dataset.selectedValue = "";
        if (field.querySelector(".option-label--selected")) field.querySelector(".option-label--selected").textContent = "";
      });

      this.setUnavailable();
      this.currentVariant = null;
    }

    handleVariantGroupImage(variant) {
      const selectedVariantData = this.variantGroupImagesData.mapping.find(
        (item) => Number(item.id) === variant.id
      );

      const selectedMedias = (initialItems) => {
        const selectedVariantMedias = Array.from(initialItems)
          .map((media) => {
            const index = selectedVariantData.media.indexOf(media.dataset.mediaId);
            const mediaType = media.dataset.mediaType;
            if (index !== -1 || mediaType !== 'image') {
              return media;
            }
            return null;
          })
          .filter(Boolean);

        if (selectedVariantMedias.length <= 0) {
          return Array.from(initialItems).map((media, index) => {
            media.dataset.index = index;

            media.removeAttribute('style'); // Avoid style of swipe slide item
            media.querySelector('.m-product-media').setAttribute("style", `--animation-order: ${index + 1};`);

            return media;
          });
        }

        const orderedMedias = Object.values(selectedVariantData.media)
          .map(id => selectedVariantMedias.find(media => media.dataset.mediaId === id))
          .filter(Boolean);

        const remainingMedias = selectedVariantMedias.filter(media => !Object.values(selectedVariantData.media).includes(media.dataset.mediaId));

        return Array.from([...orderedMedias, ...remainingMedias]).map((media, index) => {
          media.dataset.index = index;

          media.removeAttribute('style'); // Avoid style of swipe slide item
          media.querySelector('.m-product-media').setAttribute("style", `--animation-order: ${index + 1};`);

          return media;
        });
      }

      const mediaWrapper = this.productMedia.querySelector(".m-media-gallery__list");
      const thumbWrapper = this.productMedia.querySelector(".m-product-media--slider__thumbnails .swiper-wrapper");

      const layout = this.productMedia.dataset.layout;

      mediaWrapper.innerHTML = "";
      thumbWrapper.innerHTML = "";

      selectedMedias(this.initialMedias).forEach((media, index) => {
        if (layout === "layout-2") {
          media.classList.remove("m-col-span-2");
          if (index % 3 === 0) {
            media.classList.add("m-col-span-2");
          }
        }
        mediaWrapper.append(media);
      });
      selectedMedias(this.initialThumbs).forEach((media) => {
        media.classList.toggle("swiper-slide-thumb-active", media.dataset.index === "0");
        thumbWrapper.append(media);
      });
    }

    initQuantityHandlers() {
      if (this.quantityInputs.length <= 0) return;

      this.setQuantityBoundries();
      if (!this.hasAttribute("data-original-section-id")) {
        this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
          MinimogTheme.pubSubEvents.cartUpdate,
          this.fetchQuantityRules.bind(this)
        );
      }
    }

    setQuantityBoundries() {
      this.quantityInputs.forEach((input) => {
        const quantityInputWrapper = input.closest('m-quantity-input');
        quantityInputWrapper.setQuantityBoundries(this.sectionId, this.productId);
      });
    }

    fetchQuantityRules() {
      const currentVariantId = this.productForm?.variantIdInput?.value;
      if (!currentVariantId) return;

      this.querySelector('.quantity__rules-cart')?.classList.add('loading');

      fetch(
        `${this.getAttribute(
          "data-url"
        )}?variant=${currentVariantId}&section_id=${this.sectionId}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          this.updateQuantityRules(
            this.sectionId,
            this.productId,
            parsedHTML
          );
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.querySelector('.quantity__rules-cart')?.classList.remove('loading');
        });
    }

    updateQuantityRules(sectionId, productId, parsedHTML) {
      if (this.quantityInputs.length <= 0) return;

      this.quantityInputs.forEach((input) => {
        const quantityInputWrapper = input.closest('m-quantity-input');
        quantityInputWrapper.updateQuantityRules(sectionId, productId, parsedHTML);
      });

      this.setQuantityBoundries();
    }

    addRecentViewedProduct() {
      const cookies = getCookie('m-recent-viewed-products')
      let products = cookies ? JSON.parse(cookies) : []
      if (products.indexOf(MinimogSettings.productHandle) === -1) {
        products.unshift(MinimogSettings.productHandle)
        products = products.slice(0, 20)
        setCookie('m-recent-viewed-products', JSON.stringify(products));
      }
    }

    onWindowLoad() {
      this.acc = [];
      MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
      MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
      this.addRecentViewedProduct();

      addEventDelegate({
        context: this,
        selector: (window.__minimog_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
        handler: (e) => {
          const index = e.target.closest('.m-product-collapsible').dataset.index
          setTimeout(() => {
            this.acc[Number(index)].setContentHeight()
          }, 300)
        },
        capture: true
      })
    }
  }

  customElements.define("product-info", ProductInfo);
}